<app-aw-modal data-testid="categorize-locations-modal">
    <div modal-title>
        <div class="title-row">
            <span class="title">
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="29" viewBox="0 0 33 29" fill="none">
                    <path
                        d="M5.3187 20.7208C2.86942 21.2039 1.73526 20.0196 1.02439 17.8531C0.631792 16.6559 -0.179248 13.89 0.0356295 12.7494C0.591402 9.81381 4.27501 10.1854 6.38662 9.11425L17.6749 0.283305C19.3245 -0.46634 20.9643 0.326926 21.4959 2.01201C22.5476 7.33223 24.8192 12.8318 25.808 18.1068C26.1715 20.0471 25.4445 21.5545 23.349 21.737L15.0156 20.6287C14.7668 21.4058 14.5859 22.0731 14.0689 22.729C13.7748 23.1022 12.6084 23.8906 12.5857 23.986C12.5244 24.2461 13.1415 25.7244 13.1399 26.2882C13.1286 29.0751 9.35613 30.1867 7.90369 27.3271C6.88746 25.3285 6.22991 22.7969 5.3187 20.7176V20.7208ZM9.529 17.9597L22.7674 19.8468C23.5526 19.9744 24.1923 19.7272 24.0825 18.8338L19.6977 2.508C19.5313 1.77936 18.8867 1.75674 18.297 2.06371L7.70658 10.4455L9.529 17.9597ZM5.90355 11.3083C4.33317 11.9432 1.522 11.5797 1.88713 13.953C1.99537 14.6606 2.72725 17.4363 3.00029 18.0486C3.82748 19.9098 6.22668 18.3103 7.6355 18.1019L5.90355 11.3083ZM7.06195 20.1392L9.58716 26.5144C10.0492 27.613 11.2351 27.2091 11.2561 26.1622L9.58878 19.9986C9.11217 19.2813 7.74859 20.2491 7.06195 20.1376V20.1392Z"
                        fill="#67C2AC"
                    />
                    <path
                        d="M31.7759 16.4814C31.5642 16.6817 31.0149 16.6833 30.7241 16.6736C30.1312 16.6526 27.7966 16.3505 27.3216 16.1615C26.37 15.7802 26.6124 14.4182 27.6948 14.3552C28.1036 14.331 30.9196 14.7446 31.3542 14.8787C32.0328 15.0903 32.3155 15.9692 31.7743 16.483L31.7759 16.4814Z"
                        fill="#67C2AC"
                    />
                    <path
                        d="M30.3315 7.72664C31.6644 7.56831 31.9358 8.94643 31.1426 9.41011C30.8727 9.56844 27.8935 10.3989 27.5252 10.4344C26.4346 10.541 25.9597 9.29702 26.8369 8.72348C27.131 8.53122 29.8888 7.77996 30.3315 7.72664Z"
                        fill="#67C2AC"
                    />
                    <path
                        d="M28.3008 1.50318C28.7935 2.02179 28.4058 2.67935 27.9728 3.05417C27.6674 3.31752 25.5122 4.92828 25.2925 5.00422C24.1228 5.41297 23.3828 4.37413 24.2132 3.492C24.5832 3.09941 27.2409 1.18329 27.6642 1.21399C27.766 1.22207 28.2329 1.43048 28.3008 1.50157V1.50318Z"
                        fill="#67C2AC"
                    />
                </svg>
                {{ "location.categorize.title" | translate }}</span
            >
            <span class="progress" data-testid="categorize-locations-modal-progress">
                {{ "location.categorize.progress" | translate: { categorized: categorizedCount(), total: total() } }}
            </span>
        </div>
    </div>

    <div modal-body>
        <div class="intro">
            <p>{{ "location.categorize.description_1" | translate }}</p>
            <p>{{ "location.categorize.description_2" | translate }}</p>
            <p>{{ "location.categorize.description_3" | translate }}</p>
        </div>

        @for (group of groups(); track group.key) {
            <div class="group">
                <div class="group-header">
                    <button type="button" class="group-toggle" (click)="toggleGroup(group.key)" [attr.aria-expanded]="isExpanded(group.key)" [attr.data-testid]="'categorize-locations-modal-group-' + group.key + '-toggle-button'">
                        <span class="chevron" [class.chevron--open]="isExpanded(group.key)">›</span>
                        <span class="group-name">
                            @if (group.legacyGroup) {
                                {{ "misc." + group.legacyGroup.toLowerCase() | translate }}
                            } @else {
                                {{ "location.categorize.no_user_group" | translate }}
                            }
                        </span>
                        <span class="group-count">
                            {{ "location.categorize.group_progress" | translate: { categorized: groupCategorizedCount(group), total: group.locations.length } }}
                        </span>
                    </button>

                    <select class="form-select group-apply" [ngModel]="groupSelectionFor(group.key)" (ngModelChange)="applyToGroup(group, $event)" [attr.data-testid]="'categorize-locations-modal-group-' + group.key + '-apply-select'">
                        <option [ngValue]="null" disabled>{{ "location.categorize.apply_to_group" | translate }}</option>
                        @for (option of locationTypeOptions; track option.value) {
                            <option [ngValue]="option.value">{{ option.label }}</option>
                        }
                    </select>
                </div>

                @if (isExpanded(group.key)) {
                    <ul class="location-list">
                        @for (location of group.locations; track location.id) {
                            <li class="location-row">
                                <div class="location-info">
                                    <span class="location-name">{{ location.name }}</span>
                                    @if (group.legacyGroup) {
                                        <span class="location-old-group">{{ "misc." + group.legacyGroup.toLowerCase() | translate }}</span>
                                    }
                                </div>
                                <span class="arrow" aria-hidden="true">→</span>
                                <select
                                    class="form-select location-select"
                                    [ngModel]="assignmentFor(location.id)"
                                    (ngModelChange)="setLocationType(location.id, $event)"
                                    [attr.data-testid]="'categorize-locations-modal-location-' + location.id + '-type-select'"
                                >
                                    <option [ngValue]="null" disabled>{{ "location.categorize.choose_type" | translate }}</option>
                                    @for (option of locationTypeOptions; track option.value) {
                                        <option [ngValue]="option.value">{{ option.label }}</option>
                                    }
                                </select>
                            </li>
                        }
                    </ul>
                }
            </div>
        }
    </div>

    <div modal-footer>
        <app-aw-button size="large" [disabled]="!hasChanges()" [loading]="submitting()" (clickEmitter)="submit()" [dataTestId]="'categorize-locations-modal-submit-button'">
            <span button-content>{{ "location.categorize.submit" | translate }}</span>
        </app-aw-button>
    </div>
</app-aw-modal>
